import { useHealth, useMeta, useReady } from '../api/system.js';
import { QueryState } from '../components/QueryState.js';
import { t } from '../i18n/uk.js';

function Status({ ok, yes, no }: { ok: boolean; yes: string; no: string }) {
  return <span className={ok ? 'badge ok' : 'badge bad'}>{ok ? yes : no}</span>;
}

/** I0 landing screen: shows that UI → API → database are wired end to end. */
export function SystemStatusPage() {
  const health = useHealth();
  const ready = useReady();
  const meta = useMeta();

  return (
    <section>
      <h1>{t.system.title}</h1>
      <dl className="facts">
        <dt>{t.system.api}</dt>
        <dd>
          <QueryState query={health}>
            {(h) => <Status ok={h.status === 'ok'} yes={t.system.ok} no={t.system.down} />}
          </QueryState>
        </dd>
        <QueryState query={ready}>
          {(r) => (
            <>
              <dt>{t.system.database}</dt>
              <dd>
                <Status ok={r.checks.database} yes={t.system.ok} no={t.system.down} />
              </dd>
              <dt>{t.system.migrations}</dt>
              <dd>
                <Status ok={r.checks.migrations} yes={t.system.applied} no={t.system.pending} />
              </dd>
            </>
          )}
        </QueryState>
        <QueryState query={meta}>
          {(m) => (
            <>
              <dt>{t.system.apiVersion}</dt>
              <dd>{m.apiVersion}</dd>
              <dt>{t.system.build}</dt>
              <dd>
                <code>{m.build}</code>
              </dd>
            </>
          )}
        </QueryState>
      </dl>
    </section>
  );
}
